<template>
    <el-button type="text" plain  icon="el-icon-view" v-on:click="clickEvent()">{{btnCon}}</el-button>
</template>
  
  <script>
  
  export default {
    name: 'table-query-button',
    props: {
      btnCon: {
            type: String,
            default: () => {
                return "查看"
            }
        },
    },
    data () {
      return {
      }
    },
    mounted () {
    },
    methods: {
        clickEvent(){
            this.$emit('select-type',1);
        }
    }
  }
  </script>
  
  <style lang="scss">
  </style>
  


// WEBPACK FOOTER //
// TableQueryButton.vue?7997b8b2